import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

import { CanvasToolbarIconComponent } from '../../icons/canvas-toolbar-icon.component';

@Component({
  selector: 'lib-canvas-layers-toggle',
  standalone: true,
  imports: [CanvasToolbarIconComponent],
  template: `
    <button
      class="cv-layers-btn"
      [class.cv-layers-btn--active]="isActive"
      (click)="toggle.emit()"
      title="Toggle layers"
      type="button"
    >
      <lib-canvas-toolbar-icon name="layer"></lib-canvas-toolbar-icon>
    </button>
  `,
  styleUrl: './canvas-layers-toggle.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class CanvasLayersToggleComponent {
  @Input() isActive = false;
  @Output() toggle = new EventEmitter<void>();
}
